
import {
  getListUser,
  deleteUser,
  changeRole,
  getDetailUser,
  changeProfile,
  editTeacher
} from "./../api.js";

export const state = {
  listUserResponse: {},
  detailUserResponse: {},
  changeProfileResponse: {},
  editTeacherRes:{}
};

export const getters = {
  listUserResponse: state =>
    state.listUserResponse ? state.listUserResponse.data : [],
  pagination: state => (state.listUserResponse ? state.listUserResponse : {}),
  detailUserResponse: state =>
    state.detailUserResponse ? state.detailUserResponse.data : [],
  changeProfileResponse: state =>
    state.changeProfileResponse ? state.changeProfileResponse.data : [],
  editTeacherRes: state =>
    state.editTeacherRes ? state.editTeacherRes.data : {}
};

export const mutations = {
  getList(state, data) {
    state.listUserResponse = data.data;
  },
  editTeacher(state, data) {
      if (!data.error) {
          state.editTeacherRes  = data.data;
      } else {
          state.editTeacherRes = data.error.response.data;
      }
  },
  detailUser(state, data) {
    state.detailUserResponse = data.data;
  },
  changeProfile(state, data) {
    state.changeProfileResponse = data.data;
  }
};

export const actions = {
  async getList({ commit }, query) {
    let data = await getListUser(query);
    commit("getList", data);

  },
  async editTeacher({ commit }, query) {
    let data_user = await editTeacher(query);
    commit("editTeacher", data_user);
  },
  async delete({ commit }, query) {
    let data = await deleteUser(query);
    commit("getList", data);
  },

  async changeRole({ commit }, query) {
    let data = await changeRole(query);
    commit("getList", data);
  },

  async getDetail({ commit }, query) {
    let data = await getDetailUser(query);
    commit("detailUser", data);
  },

  async changeProfile({ commit }, query) {
    let data = await changeProfile(query);
    commit("changeProfile", data);
  }
};
